import { type FC, useContext } from 'react';
import { cubicBezier, motion } from 'framer-motion';

import { ClaimAnimationContext } from '@/context/ClaimAnimationContext';

import css from './styles.module.scss';

interface StockAnimationProps {
  animationValues: {
    first: number;
    second: number;
    third: number;
    fourth: number;
  };
}

const StockAnimation: FC<StockAnimationProps> = ({ animationValues }) => {
  const { setIsStockAnimationStart } = useContext(ClaimAnimationContext);

  return (
    <>
      <motion.span
        className={css.stock}
        initial={{ opacity: 1 }}
        animate={{ opacity: 0 }}
        transition={{
          ease: cubicBezier(0.36, 0, 0.66, -0.56),
          duration: 0.2,
        }}
      >
        {animationValues.first}
      </motion.span>
      <motion.span
        className={css.stock}
        initial={{ opacity: 0 }}
        animate={{ opacity: [null, 1, 0] }}
        transition={{
          ease: 'easeOut',
          duration: 0.4,
        }}
      >
        {animationValues.second}
      </motion.span>
      <motion.span
        className={css.stock}
        initial={{ opacity: 0 }}
        animate={{ opacity: [null, 1, 0] }}
        transition={{
          delay: 0.2,
          ease: 'easeOut',
          duration: 0.4,
        }}
      >
        {animationValues.third}
      </motion.span>
      <motion.span
        onAnimationComplete={() => {
          setIsStockAnimationStart(false);
        }}
        className={css.stock}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          delay: 0.4,
          ease: 'easeOut',
          duration: 0.2,
        }}
      >
        {animationValues.fourth}
      </motion.span>
    </>
  );
};

export { StockAnimation };
